import React, { useEffect, useRef, useState } from 'react';

import { Button, Form, Input, Layout, Modal, Select, Table } from 'antd';

import posv2 from '../../../lib/posv2';

const { Search } = Input;
const { Content } = Layout;
const { Option } = Select;

const columns = [
  {
    title: '名稱',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '車牌',
    dataIndex: 'plate',
    key: 'plate',
  },
  {
    title: '單位',
    dataIndex: 'plate',
    key: 'dept',
    render: (_, record) => {
      return record.dept?.name ?? '';
    },
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    render: (_, record) => {
      return (
        <Button
          type='link'
          icon='edit'
          onClick={() => {
            record._update();
          }}
        >
          修改
        </Button>
      );
    },
  },
];

const UpdateModal = Form.create()(
  ({ black, visible, onOk, onCancel, form }) => {
    const { getFieldDecorator, setFieldsValue, validateFields } = form;

    const preBlack = useRef(black);

    const [depts, setDepts] = useState([]);

    const initDepts = async () => {
      let depts = await posv2.findDepts({
        page_size: 1000,
      });

      depts = depts.content;

      if (depts) {
        setDepts(depts);
      }
    };

    useEffect(() => {
      if (black.id === preBlack.current.id) {
        return;
      }

      preBlack.current = black;
      setFieldsValue(black);
    }, [black]);

    useEffect(() => {
      initDepts();
    }, []);

    const upload = async values => {
      let form = {
        name: values.name,
        plate: values.plate,
        dept_id: values.dept_id,
      };

      try {
        await posv2.updateBlack(black.id, form);
      } catch (err) {
        console.error(err);
      }

      onOk && onOk();
    };

    const onSubmit = () => {
      validateFields((err, values) => {
        if (err) {
          console.error(err);
          return;
        }

        upload(values);
      });
    };

    return (
      <Modal
        title='修改黑名單'
        visible={visible}
        onOk={() => {
          onSubmit();
        }}
        onCancel={() => {
          onCancel && onCancel();
        }}
        okText='確定'
        cancelText='取消'
      >
        <Form>
          <Form.Item>
            名稱:
            {getFieldDecorator('name', {
              rules: [{ required: true, message: '請輸入名稱!' }],
              initialValue: black.name,
            })(<Input placeholder='AIRIDER' />)}
          </Form.Item>
          <Form.Item>
            車牌:
            {getFieldDecorator('plate', {
              rules: [{ required: true, message: '請輸入車牌' }],
              initialValue: black.plate,
            })(<Input placeholder='ABC1234' />)}
          </Form.Item>

          <Form.Item label='單位' style={{ marginBottom: 0 }}>
            {getFieldDecorator('dept_id', {
              rules: [],
              initialValue: black && black.dept ? black.dept.id : null,
            })(
              <Select style={{ width: 200 }}>
                {depts.map(s => {
                  return (
                    <Option key={s.id} value={s.id}>
                      {s.name}
                    </Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
);

const AddModal = Form.create()(({ visible, onOk, onCancel, form }) => {
  const { getFieldDecorator, setFieldsValue, validateFields } = form;

  const [depts, setDepts] = useState([]);

  const initDepts = async () => {
    let depts = await posv2.findDepts({
      page_size: 1000,
    });

    depts = depts.content;

    console.log(depts);

    if (depts) {
      setDepts(depts);
    }
  };

  useEffect(() => {
    initDepts();
  }, []);

  const upload = async values => {
    let form = {
      name: values.name,
      plate: values.plate,
      dept_id: values.dept_id,
    };

    try {
      await posv2.addBlack(form);
    } catch (err) {
      console.error(err);
    }

    onOk && onOk();
  };

  const onSubmit = () => {
    validateFields((err, values) => {
      if (err) {
        console.error(err);
        return;
      }

      upload(values);
    });
  };

  return (
    <Modal
      title='新增黑名單'
      visible={visible}
      onOk={() => {
        onSubmit();
      }}
      onCancel={() => {
        onCancel && onCancel();
      }}
      okText='確定'
      cancelText='取消'
    >
      <Form>
        <Form.Item>
          名稱:
          {getFieldDecorator('name', {
            rules: [{ required: true, message: '請輸入名稱!' }],
          })(<Input placeholder='AIRIDER' />)}
        </Form.Item>
        <Form.Item>
          車牌:
          {getFieldDecorator('plate', {
            rules: [{ required: true, message: '請輸入車牌' }],
          })(<Input placeholder='ABC1234' />)}
        </Form.Item>

        <Form.Item label='單位' style={{ marginBottom: 0 }}>
          {getFieldDecorator('dept_id', {
            rules: [],
          })(
            <Select style={{ width: 200 }}>
              {depts.map(s => {
                return (
                  <Option key={s.id} value={s.id}>
                    {s.name}
                  </Option>
                );
              })}
            </Select>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
});

export default function BlackList({ className, children }) {
  const [blacks, setBlacks] = useState([]);

  const [selected, setSelected] = useState(null);

  const [selectedKeys, setSelectedKeys] = useState([]);

  const [state, setState] = useState('view');

  useEffect(() => {
    if (state !== 'view') {
      return;
    }

    const loadBlacks = async () => {
      try {
        let resp = await posv2.findBlackList({});
        const { content } = resp;

        for (let i = 0; i < content.length; i++) {
          let g = content[i];

          g.key = g.id;
          g._update = () => {
            setSelected(g);
            setState('update');
          };
        }

        setBlacks(content);
      } catch (error) {
        console.error(error);
      }
    };
    loadBlacks();
  }, [state]);

  const onAdd = () => {
    setState('add');
  };

  const onDelete = async () => {
    try {
      await posv2.removeBlack(selectedKeys);
    } catch (err) {
      console.error(err);
    }

    setState('view');
  };

  return (
    <div>
      <div
        style={{
          padding: '0px 16px',
        }}
      >
        <Content
          style={{
            margin: '12px 0px 16px 0px',
            padding: '24px',
            background: '#fff',
            minHeight: 80,
          }}
        >
          <div style={{ float: 'left' }}>
            <Button type='link' icon='plus' onClick={onAdd}>
              新增
            </Button>

            <Button
              type='link'
              icon='delete'
              onClick={() => {
                setState('delete');

                Modal.confirm({
                  title: '刪除資料',
                  onOk: () => {
                    onDelete();
                  },
                });
              }}
            >
              刪除
            </Button>
          </div>
        </Content>
      </div>

      <Content
        style={{
          margin: '24px 16px',
          padding: 24,
          background: '#fff',
          minHeight: 280,
        }}
      >
        <Table
          columns={columns}
          dataSource={blacks}
          pagination={true}
          rowSelection={{
            onChange: selectedRowKeys => {
              setSelectedKeys(selectedRowKeys);
            },
          }}
        />
      </Content>
      <AddModal
        visible={state === 'add'}
        onOk={() => {
          setState('view');
        }}
        onCancel={() => {
          setState('view');
        }}
      />
      {selected && (
        <UpdateModal
          black={selected}
          visible={state === 'update'}
          onOk={() => {
            setState('view');
          }}
          onCancel={() => {
            setState('view');
          }}
        />
      )}
    </div>
  );
}
